import * as Yup from 'yup'

import { vendorDepotSettingsSchema } from 'modules/vendors/constants/vendorValidation'

export const validationSchema = Yup.object({
  ...vendorDepotSettingsSchema,
})
